import { AuthService } from '../../service/auth.service';
import { Component, OnInit,ViewContainerRef } from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {AngularFirestore,AngularFirestoreCollection} from '@angular/fire/firestore';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/map';


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {
  image: File;
  aboutusForm:FormGroup;
  FOLDER: any = 'about/';
  loading: any = false;
  aboutimgurl: any = '';
  edit: any = false;
  id: any;
  error: any = ''
  constructor(private form:FormBuilder,private router:Router ,private afs:AngularFirestore,private auth: AuthService,
    public toastr: ToastsManager,vcr: ViewContainerRef) {
      this.toastr.setRootViewContainerRef(vcr);
     }

  ngOnInit() {
    this.aboutusForm = this.form.group({
      content: ['', [Validators.required]],
      upload_Image: ['', []]
    });
    this.checkdata();
  }
  async checkdata() {
    try {
      const aboutdata = await this.afs.collection('/Aboutus').valueChanges();
      aboutdata.subscribe(aboutusdata => {
        console.log(aboutusdata);

        if (aboutusdata.length >= 1) {
          this.aboutusForm.get('content').setValue(aboutusdata[0]['heading']);
          this.aboutimgurl = aboutusdata[0]['imageurl'];
          this.edit = true;
          this.id = aboutusdata[0]['id'];
        }
      });
    } catch (error) {
      this.error = 'Somthing went wrong please try later';
      this.toastr.error('Somthing went wrong please try later!', 'Oops!');
      console.log(error);
    }
  }
  changeListner2(event) {
    this.image = <File>event.target.files[0];
  }

  async addabout(value, valid) {
    this.error = '';
    if (valid || this.edit) {
      this.loading = true;
     
      try {
        let uploadedimage;
        if (this.edit) {

          if (this.image) {
            uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
            await this.afs.doc('Aboutus/' + this.id).update({ heading: value.content, imageurl: uploadedimage['Location']});
          } else {
            await this.afs.doc('Aboutus/' + this.id).update({ heading: value.content });
          }
        } else {
          if(!this.image){
          this.error = 'Image is required';
          this.toastr.error('Image is required!', 'Oops!');
          }
          uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
          const addAboutus = await this.afs.collection('Aboutus')
          .add({ heading: value.content, imageurl: uploadedimage['Location'], type: 'mobile' });
          const id = addAboutus.id;
          await this.afs.doc(`/Aboutus/${id}`).update({id: id});
        }
       
        this.loading = false;
        this.toastr.success('AboutUs Updated!', 'Success!');
        

      } catch (error) {
        this.loading = false;
        this.toastr.error('Somthing went wrong please try later!', 'Oops!');
        console.log(error);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/extras/about-us/about-us.component.ts